import { useState } from "react";
import { Field, FormResult, useFormSubmit, emailOk, SubmitButton, Honeypot } from "./FormKit";

const validate = (v) => {
  const e = {};
  if ((v.name || "").trim().length < 2) e.name = "Please enter your name";
  if (!emailOk(v.email)) e.email = "Please enter a valid email address";
  if (v.phone && !/^[0-9 +()-]{6,40}$/.test(v.phone)) e.phone = "Please enter a valid phone number";
  if ((v.message || "").trim().length < 10) e.message = "Please tell us a little more (10+ characters)";
  return e;
};

export function ContactForm({ product = "", defaultSubject = "" }) {
  const [v, setV] = useState({ name: "", email: "", phone: "", subject: defaultSubject, message: "", product, website: "" });
  const [state, submit] = useFormSubmit("/forms/contact", validate);
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  if (state.status === "success") return <FormResult {...state} testPrefix="contact-form" />;
  const err = state.errors;
  return (
    <form noValidate onSubmit={(e) => { e.preventDefault(); submit(v); }} className="relative space-y-5" data-testid="contact-form">
      <Honeypot value={v.website} onChange={(x) => setV({ ...v, website: x })} />
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Name *" id="contact-name" error={err.name}><input id="contact-name" className="field" value={v.name} onChange={set("name")} autoComplete="name" data-testid="contact-name-input" /></Field>
        <Field label="Email *" id="contact-email" error={err.email}><input id="contact-email" type="email" className="field" value={v.email} onChange={set("email")} autoComplete="email" data-testid="contact-email-input" /></Field>
        <Field label="Phone" id="contact-phone" error={err.phone}><input id="contact-phone" type="tel" className="field" value={v.phone} onChange={set("phone")} autoComplete="tel" data-testid="contact-phone-input" /></Field>
        <Field label="Subject" id="contact-subject"><input id="contact-subject" className="field" value={v.subject} onChange={set("subject")} data-testid="contact-subject-input" /></Field>
      </div>
      {product && <p className="font-mono text-xs text-slate-400">Enquiring about: <span className="text-slate-200">{product}</span></p>}
      <Field label="Message *" id="contact-message" error={err.message}><textarea id="contact-message" rows={6} className="field resize-y" value={v.message} onChange={set("message")} data-testid="contact-message-input" /></Field>
      <FormResult {...state} testPrefix="contact-form" />
      <SubmitButton busy={state.status === "busy"} testId="contact-submit-button">Send enquiry</SubmitButton>
    </form>
  );
}
